import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withButtonPanelConfiguration
    from "./../../core/components/buttonpanel/configuration/withButtonPanelConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import PIXI from "pixi.js";
import { isMobile } from "react-device-detect";
import { actions as reelsActions } from "../../core/reducers/reelsStateReducer";
import { actions as reelsGridActions, actions as reelGridActions } from "../../core/reducers/reelgridStateReducer";
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";
import { actions as basegameActions, actions as baseGameActions } from "../../core/reducers/baseGameReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as paytableActions } from "../../core/reducers/paytableReducer";
import { actions as autoplayActions } from "../../core/reducers/autoplayReducer";
import { actions as menuActions } from "../../core/reducers/menuReducer";
import { actions as desktopSettingPanelActions } from "../../core/reducers/desktopSettingPanelReducer";
import { actions as betPanelAction } from "../../core/reducers/betPanelReducer";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import {
    configGame
} from "../../data/config";
import { TIMER } from "../../core/utills";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as gameLevelResponseActions } from "../../gamereducer/asyncGameLevelServerResponseReducer";
import { actions as behaviourAction } from "../../gamereducer/behaviourReducer";
import { actions as winShowerActions } from "../../gamereducer/winShowerReducer";
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { actions as lockedReelActions } from "../../gamereducer/lockedReelReducer";
import { server } from "./../../core/data/config";

import { actions as aplicationActions } from "../../core/reducers/applicationStateReducer";

import { Texture } from "pixi.js";
import { actions as mainSettingPanelActions } from "../../gamereducer/mainSettingPanelMobReducer";
import { setTimeout } from "timers";

interface IProps {
    [x: string]: any;
}

interface IStore {
    [x: string]: any;
}


interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class ButtonPanelGenericUI extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected buttonPanelGenericUIContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected button_name_1: string;
    protected button_name_2: string;
    protected button_name_3: string;
    protected button_name_4: string;
    protected button_name_5: string;
    protected button_name_6: string;
    protected button_name_7: string;
    protected button_name_8: string;
    protected button_name_9: string;
    protected button_name_10: string;
    protected button_name_11: string;
    protected button_name_12: string;
    protected button_name_13: string;
    protected button_name_14: string;
    protected button_name_15: string;
    protected button_name_16: string;
    protected button_name_17: string;
    protected button_name_18: string;
    protected button_name_19: string;
    protected button_name_20: string;
    protected button_name_21: string;
    protected button_name_22: string;

    protected alwaysHideButton: any;
    protected hitAreaGraphic: any;
    protected betValueObject: any;
    protected winValueObject: any;
    protected coinValueObject: any;
    protected balanceValueObject: any;
    protected autoplayCounterObject: any;
    protected autoplayStopButtonObject: any;
    protected autoplayStopButtonX: number = 477;
    protected autoplayStopButtonY: number = 1361;
    protected autoplayCounterX: number = 518;
    protected autoplayCounterY: number = 1403;
    protected textScaling: number = 0.9;
    protected btnEnableGap: number = 0;
    protected btnDisableTime: number = 0;
    protected btnEnableTime: number = 0;
    protected spaceBarSpinstoreValueChanged: boolean;
    protected menuBtnClicked: boolean;


    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.button_name_1 = "btn_spin";
        this.button_name_2 = "btn_paytable";
        this.button_name_3 = "btn_bet_increase";
        this.button_name_4 = "btn_bet_decrease";
        this.button_name_5 = "btn_sound";
        this.button_name_6 = "btn_gameRule";
        this.button_name_7 = "btn_autoplay_stopdesktop";
        this.button_name_8 = "btn_autoplay";
        this.button_name_9 = "btn_home";
        this.button_name_10 = "btn_maxbet";
        this.button_name_11 = "btn_setting";
        this.button_name_12 = "btn_autoplay2";
        this.button_name_13 = "btn_soundOff";
        this.button_name_14 = "btn_menu";
        this.button_name_15 = "btn_menu_close";
        this.button_name_16 = "btn_stake";
        this.button_name_17 = "btn_minbet";
        this.button_name_18 = "btn_game_rules";
        this.button_name_19 = "btn_history";
        this.button_name_20 = "btn_autoplay_stopmobile";
        this.button_name_21 = "btn_spinStop";
        this.button_name_22 = "btn_game_exit";

        this.alwaysHideButton = [];

        this.buttonPanelGenericUIContainer = React.createRef();
        this.state = {
            [this.button_name_1]: { enable: false },
            [this.button_name_2]: { enable: false },
            [this.button_name_3]: { enable: false },
            [this.button_name_4]: { enable: false },
            [this.button_name_5]: { enable: false },
            [this.button_name_6]: { enable: false },
            [this.button_name_7]: { enable: false },
            [this.button_name_8]: { enable: false },
            [this.button_name_9]: { enable: false },
            [this.button_name_10]: { enable: false },
            [this.button_name_11]: { enable: false },
            [this.button_name_12]: { enable: false },
            [this.button_name_13]: { enable: false },
            [this.button_name_14]: { enable: false },
            //[this.button_name_15]: { enable: false },
            [this.button_name_16]: { enable: false },
            [this.button_name_17]: { enable: false },
            [this.button_name_20]: { enable: false },
            [this.button_name_21]: { enable: false },


            firstLoad: 1
        }
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));
        this.spaceBarSpinstoreValueChanged = false;
        this.menuBtnClicked = false;
        this.setVisibilityOfButtonAccordingToBackend();
    }

    //this method is setting visibility of button from coming backend
    setVisibilityOfButtonAccordingToBackend() {
        this.displayUI.map((data: any) => {


            if (data.name === this.button_name_8) {
                data.visible = true;
                if ((window as any).GAME_INFO.disableAutoplay
                ) {
                    this.alwaysHideButton.push(this.button_name_8)
                    //data.visible = false;
                }
            }


            if (data.name === this.button_name_1) {
                data.visible = true;
            }
            if (data.name === this.button_name_2) {
                data.visible = true;
            }
            if (data.name === this.button_name_3) {
                // data.visible = this.props.increaseBetBtnVisibility;
            }
            if (data.name === this.button_name_4) {
                //data.visible = this.props.decreaseBetBtnVisibility;
            }
            if (data.name === this.button_name_10) {
                //data.visible = this.props.maxBetBtnVisibility;
            }
            if (data.name === this.button_name_17) {
                //data.visible = this.props.maxBetBtnVisibility;
            }
            // if (data.name === "btn_autoplay") {
            //     data.visible = true;
            // }
            if (data.name === "btn_autoplay_stop" + this.ui_mode) {
                //data.visible = false;
            }
            // if (isMobile) {
            //     if (data.name === "btn_autoplay_stop") {
            //         data.visible = false;
            //     }
            // }
        })

    }

    setBetPanelVisibility() {
        let betPanelContainer: any = UIManager.getRef("betPanelContainer");
        betPanelContainer && (betPanelContainer.visible = true);
    }

    openBetPanel() {
        let betPanelContainer: any = UIManager.getRef("betPanelContainer");
        if (betPanelContainer) {
            let label_BetPanel_value: any = UIManager.getRef("label_BetPanel_value");
            label_BetPanel_value && (label_BetPanel_value.visible = true);
            betPanelContainer.addChild(label_BetPanel_value);
            betPanelContainer.visible = true;
            betPanelContainer.alpha = 0;
            this.addFadeTween(betPanelContainer, 0.3, 0, 1)
            let timer = TIMER.TimerManager.createTimer(300);
            timer.on('end', (e: any) => {
                e.remove();
                this.hitAreaActive();
            });
            timer.start();
        }
    }

    hitAreaActive() {
        this.hitAreaGraphic = UIManager.getRef("winCelebration_Graphic");
        this.hitAreaGraphic.interactive = true;
        this.hitAreaGraphic.click = (event: any) => {
            let betPanelContainer: any = UIManager.getRef("betPanelContainer");
            this.addFadeTween(betPanelContainer, 0.3, 1, 0)
            this.hitAreaDeactivate();
            //label_BetPanel_value.visible = false;
        }

        this.hitAreaGraphic.addListener('touchend', (evt: MouseEvent): void => {
            let betPanelContainer: any = UIManager.getRef("betPanelContainer");
            this.addFadeTween(betPanelContainer, 0.3, 1, 0)
            this.hitAreaDeactivate();
        })

    }
    hitAreaDeactivate() {
        this.hitAreaGraphic.interactive = false;
        this.hitAreaGraphic.buttonMode = false;
    }

    addFadeTween(displayObj: any, duration: number, startValue: number, endValue: number) {
        if (displayObj) {
            new Tween(
                [displayObj],
                {
                    'alpha': { start: startValue, end: endValue }
                },
                duration,
                easing.easeLinear,
                false, null, null, null, null, false, null, () => {

                }
            );
        }

    }

    openMenuPanel() {

        let menuBtnClose: any = UIManager.getRef("btn_menu_close");
        menuBtnClose && (menuBtnClose.visible = true);
        let historyBtn: any = UIManager.getRef("historyBtnContainer");
        historyBtn && (historyBtn.visible = true);
        let settingBtn: any = UIManager.getRef("settingBtnContainer");
        settingBtn && (settingBtn.visible = true);
        let gameRuleBtn: any = UIManager.getRef("gameRulesBtnContainer");
        gameRuleBtn && (gameRuleBtn.visible = true);
        let gameBtnExit: any = UIManager.getRef("btn_game_exit");
        if (this.props.homeButton) {
            gameBtnExit && (gameBtnExit.visible = true);
        } else {
            gameBtnExit && (gameBtnExit.visible = false);
        }

        this.addTweenToButtons(historyBtn, 855, 0.2);
        this.addTweenToButtons(settingBtn, 760, 0.2);
        this.addTweenToButtons(gameRuleBtn, 670, 0.2);
        this.addTweenToButtons(gameBtnExit, 580, 0.2);
        //this.addTweenToButtons(menuBtnClose, 500, 0.2);
        this.menuBtnClicked = true;
        let timer1 = TIMER.TimerManager.createTimer(500);
        timer1.on('end', (e: any) => {
            e.remove();
            this.menuBtnClicked = false;
        })
        timer1.start();
    }
    closeMenuPanel() {

        let menuBtn: any = UIManager.getRef("btn_menu");
        menuBtn.visible = true;
        let historyBtn: any = UIManager.getRef("historyBtnContainer");
        let settingBtn: any = UIManager.getRef("settingBtnContainer");
        let gameRuleBtn: any = UIManager.getRef("gameRulesBtnContainer");
        let gameBtnExit: any = UIManager.getRef("btn_game_exit");
        this.addTweenToButtons(gameRuleBtn, 954, 0.2);
        this.addTweenToButtons(settingBtn, 954, 0.2);
        this.addTweenToButtons(historyBtn, 954, 0.2);
        this.addTweenToButtons(gameBtnExit, 954, 0.2);
        gameBtnExit.visible = false;
        //this.addTweenToButtons(menuBtn, 400, 0.2);
        this.props.showSettingGameRules(false);
        this.props.showBetHistory(false);
        this.props.setShowGameSettings(false);
        this.hideHighLightedButton();
        this.showOtherControls();
        this.handleButtonsOnCloseMenu();
        this.props.setApplicationPause(false);
        if (this.spaceBarSpinstoreValueChanged == true) {
            this.props.spaceBarSpin(this.props.spinWithSpaceBar);
        } else {
            this.props.spaceBarSpin(!(window as any).GAME_INFO.spacebarDisabled);
            // temp hack to remove spacebar spinning as it allows you to bet below stake
            this.props.spaceBarSpin(!true);
        }


    }

    showHighLightedButton(btnName: any) {
        switch (btnName) {
            case "btn_history":
                UIManager.getRef("btn_history").visible = false;
                UIManager.getRef("btn_setting").visible = true;
                UIManager.getRef("btn_game_rules").visible = true;
                this.props.showSettingGameRules(false);
                this.props.setShowGameSettings(false);
                this.hideOtherControls();
                break;
            case "btn_setting":
                UIManager.getRef("btn_setting").visible = false;
                UIManager.getRef("btn_history").visible = true;
                UIManager.getRef("btn_game_rules").visible = true;
                this.props.showSettingGameRules(false);
                this.props.showBetHistory(false);
                this.hideOtherControls();
                break;
            case "btn_game_rules":
                UIManager.getRef("btn_game_rules").visible = false;
                UIManager.getRef("btn_history").visible = true;
                UIManager.getRef("btn_setting").visible = true;
                this.props.showBetHistory(false);
                this.props.setShowGameSettings(false);
                this.hideOtherControls();
                break;
            default:
                break;
        }


    }


    hideHighLightedButton() {
        UIManager.getRef("btn_history") && (UIManager.getRef("btn_history").visible = true);
        UIManager.getRef("btn_setting") && (UIManager.getRef("btn_setting").visible = true);
        UIManager.getRef("btn_game_rules") && (UIManager.getRef("btn_game_rules").visible = true);
    }

    hideOtherControls() {

        UIManager.getRef("btn_spin") && (UIManager.getRef("btn_spin").visible = false);
        UIManager.getRef("btn_autoplay_stop" + this.ui_mode) && (UIManager.getRef("btn_autoplay_stop" + this.ui_mode).visible = false);
        UIManager.getRef("btn_autoplay_start") && (UIManager.getRef("btn_autoplay_start").visible = false);
        UIManager.getRef("btn_autoplay") && (UIManager.getRef("btn_autoplay").visible = false);
        UIManager.getRef("btn_stake") && (UIManager.getRef("btn_stake").visible = false);
    }

    showOtherControls() {

        UIManager.getRef("btn_spin") && (UIManager.getRef("btn_spin").visible = true);
        //UIManager.getRef("btn_autoplay_stop").visible = true;
        UIManager.getRef("btn_autoplay_start") && (UIManager.getRef("btn_autoplay_start").visible = true);
        UIManager.getRef("btn_autoplay") && (UIManager.getRef("btn_autoplay").visible = true);
        UIManager.getRef("btn_stake") && (UIManager.getRef("btn_stake").visible = true);
    }

    addTweenToButtons(btn: any, ypos: number, duration: number) {
        if (btn) {
            new Tween(
                [btn],
                {
                    'y': { start: btn.y, end: ypos }
                },
                duration,
                easing.easeLinear,
                false, null, null, null, null, false, null, () => {
                    btn.y = ypos;

                }
            );
        }

    }

    //this method will decrease the bet
    onBetDecrease() {
        this.props.setInsufficientFunds(false);
        this.props.setBuyFeatureStakeExceeds(false);
        if (this.props.selectedCoin === 0) {

        } else {
            this.props.setSelectedCoin(this.props.selectedCoin - 1)
        }

        this.updateStakeParameter()
    }

    //this method will increase the bet
    onBetIncrease() {
        this.props.setInsufficientFunds(false);
        this.props.setBuyFeatureStakeExceeds(false);
        if (this.props.selectedCoin === this.props.coinList.length - 1) {

        } else {
            this.props.setSelectedCoin(this.props.selectedCoin + 1)

        }
        this.updateStakeParameter()
    }

    updateStakeParameter() {
        // let postfixStr = server.configGame.postfixpathToSend;
        // let queryString = "";
        // queryString = postfixStr + "&stake=" + this.props.coinList[this.props.selectedCoin] * 100
        // server.configGame.postfixpath = queryString

    }

    disableBetButtons() {

        let btn_bet_increaseBtn: any = UIManager.getRef("btn_bet_increase");
        let btn_bet_decreaseBtn: any = UIManager.getRef("btn_bet_decrease");
        let btn_minbetBtn: any = UIManager.getRef("btn_minbet");
        let btn_maxbetBtn: any = UIManager.getRef("btn_maxbet");

        btn_bet_increaseBtn.texture = Texture.from("plus_up.png");
        btn_bet_increaseBtn.interactive = true;
        btn_maxbetBtn.texture = Texture.from("max_up.png");
        btn_maxbetBtn.interactive = true;
        btn_bet_decreaseBtn.texture = Texture.from("minus_up.png");
        btn_bet_decreaseBtn.interactive = true;
        btn_minbetBtn.texture = Texture.from("min_up.png");
        btn_minbetBtn.interactive = true;

        if (this.props.selectedCoin === 0) {
            btn_bet_decreaseBtn.texture = Texture.from("minus_disable.png");
            btn_bet_decreaseBtn.interactive = false;
            btn_minbetBtn.texture = Texture.from("min_disable.png");
            btn_minbetBtn.interactive = false;
            btn_bet_increaseBtn.texture = Texture.from("plus_up.png");
            btn_bet_increaseBtn.interactive = true;
            btn_maxbetBtn.texture = Texture.from("max_up.png");
            btn_maxbetBtn.interactive = true;

        } else if (this.props.selectedCoin === this.props.coinList.length - 1) {
            btn_bet_increaseBtn.texture = Texture.from("plus_disable.png");
            btn_bet_increaseBtn.interactive = false;
            btn_maxbetBtn.texture = Texture.from("max_disable.png");
            btn_maxbetBtn.interactive = false;

            btn_bet_decreaseBtn.texture = Texture.from("minus_up.png");
            btn_bet_decreaseBtn.interactive = true;
            btn_minbetBtn.texture = Texture.from("min_up.png");
            btn_minbetBtn.interactive = true;

        }
    }

    showAutoPlayStartButton() {
        let autoPlayStartBtn: any = UIManager.getRef("btn_autoplay_start");
        let autoPlayBtn: any = UIManager.getRef("btn_autoplay");
        autoPlayStartBtn && (autoPlayStartBtn.visible = true);
        autoPlayBtn && (autoPlayBtn.visible = false);
    }

    //this method will show autoplay
    onAutoplayShow() {
        this.props.showAutoplay();
        this.props.setAllButtonDisable();
        this.props.setBuyFeatureStakeExceeds(false);
    }

    onAutoplay() {

        this.props.setApplicationAutoplayCount(this.props.AutoplayCount);
        this.props.startAutoplay();
        this.onSpin();
    }

    //this method will show menu
    onMenuShow() {
        this.props.showMenuUI();
        this.props.limitOfLoss(false);
        this.props.setAllButtonDisable();
    }

    //this method will call when autoplay gets stop and it will set autoplay stop button state disable
    onAutoplayStop() {

        this.setState((prevState) => {
            return {
                ...prevState,
                ["btn_autoplay_stop" + this.ui_mode]: { enable: false }
            }
        })
        this.props.setApplicationAutoplayCount(0);
        this.props.stopAutoplay();


    }
    homeButtonClicked() {
        (window as any).CLIENT_WRAPPER_INIT.send("game-close");
        if ((window as any).CLIENT_WRAPPER_INIT.doLobbyURLNavigate) {
            (window as any).top.location.href = (window as any).GAME_INFO.lobbyurl;
        }
    }
    onStopSpin() {

        this.props.forceStopSpin();
        //this.props.setStopActive(false);
        // this.setState((prevState) => {
        //     return {
        //         ...prevState,
        //         ["btn_autoplay_stop" + this.ui_mode]: { enable: false }
        //     }
        // })
        // this.props.setApplicationAutoplayCount(0);
        // this.props.stopAutoplay();


    }


    //this method helps to set the property true for showing paytable
    onPaytable() {
        this.props.showPaytable();
        this.closeMenuPanel();
    }


    //this method helps to set the property true for spinning
    onSpin() {

        ///check balance condition nextProps.balance - nextProps.coinList[nextProps.selectedCoin]
        this.props.setBuyFeatureStakeExceeds(false);
        if (this.props.balance - this.props.coinList[this.props.selectedCoin] < 0) {
            this.props.setInsufficientFunds(true);
        } else {
            //this.props.setStopActive(true);
            this.props.getApplicationSpinResponse();
            this.props.stopWinPresentation()
            this.props.setAllButtonDisable();
            this.props.resetReelState();



            if (!isMobile) {
                var d = new Date();
                var n = d.getTime();
                this.btnDisableTime = n;
                if (Number(configGame["SPIN_TYPE"]) === 0) {
                    const {
                        startSpin
                    } = this.props;
                    startSpin();
                } else if (Number(configGame["SPIN_TYPE"]) === 2) {
                    const {
                        startRGSpin
                    } = this.props;
                    startRGSpin();
                } else {
                    const {
                        startGridSpin
                    } = this.props;
                    startGridSpin();
                }
            }
        }
    }

    sendSpinAfterBlast() {

        this.props.getApplicationSpinResponse();
    }

    //this method will handle sounds on button's visibility accordingly
    soundOnButtonFunctionality() {
        if (this.props.soundIsPlaying) {
            this.props.playingSound(false);
            this.props.stopAllBGMSound(true);
            this.props.stopAllSFXSound(true);
        }

    }

    //this method will handle mute button's visibility accordingly
    soundOffButtonFunctionality() {
        this.props.soundLoadStartFunction(true);
        if (this.props.soundIsPlaying) {
            this.props.playingSound(false);
            this.props.stopAllBGMSound(true);
            this.props.stopAllSFXSound(true);
        } else {
            this.props.stopAllBGMSound(false);
            this.props.stopAllSFXSound(false);
            this.props.playingSound(true);
        }
    }

    //this panel will hit the property by which setting panel will display or hide
    settingPanelDisplayFunctionality() {
        if (this.props.showSettingPanelUI) {
            this.props.showDesktopSettingPanelUI(false);
            this.props.setAllButtonEnable();
        } else {
            this.props.showDesktopSettingPanelUI(true);
            //this.props.setAllButtonDisable();
        }
    }

    openGameRules() {
        this.props.showSettingGameRules(true);
    }
    openBetHistory() {
        this.props.getApplicationHistoryResponse();
        this.props.showBetHistory(true);
    }

    openGameSettigsPanel() {
        this.props.setShowGameSettings(true);
    }


    hideButtons() {
        // this.props.
    }
    openMenuFromWrapper() {
        UIManager.getRef("btn_menu").visible = false;
        this.openMenuPanel();
        //this.props.showSettingGameRules(true);
        //  this.hideOtherControls();
    }
    closeMenuFromWrapper() {

        this.closeMenuPanel();
    }
    //this method will be called when a button gets clicked
    handleEvent = (e: any) => {
        this.props.setApplicationButtonClicked(true);
        this.props.setApplicationButtonClicked(false);

        this.showHighLightedButton(e.target.name)
        switch (e.target.name) {
            case this.button_name_1:
                this.props.setApplicationSpinButtonClicked(true);
                this.onSpin();
                return;
            case this.button_name_2:
                this.props.setBuyFeatureStakeExceeds(false);
                if (isMobile) {
                    // if (this.props.oneClickRules) {
                    //     this.props.showSettingPanelContainerForMobile(true, "guide");
                    //     this.props.setApplicationButtonpanelVisibility(false);
                    // }
                    // else {
                    //     this.props.showSettingPanelContainerForMobile(true, "paytable");
                    //     this.props.setApplicationButtonpanelVisibility(false);
                    // }
                    this.props.showSettingPanelContainerForMobile(true, "paytable");
                    this.props.setApplicationButtonpanelVisibility(false);

                }
                //  if (isMobile) {
                //      this.props.showSettingPanelContainerForMobile(true, "paytable");
                //      this.props.setApplicationButtonpanelVisibility(false);
                //  }
                else {

                    // if (this.props.oneClickRules) {

                    //     if (this.props.showGameRules) {
                    //         this.onPaytable();
                    //     }
                    //     else {

                    //         this.props.setMenuButtonClicked(true);
                    //         UIManager.getRef("btn_menu").visible = false;
                    //         this.openMenuPanel();
                    //         this.props.showSettingGameRules(true);
                    //         this.hideOtherControls();
                    //     }
                    // } else {
                    //     this.onPaytable();
                    // }
                    this.onPaytable();

                }
                return;
            case this.button_name_3:
                // UIManager.getRef("text_win_value1") &&  (UIManager.getRef("text_win_value1").visible=false);
                //this.props.getApplicationIncreaseBetResponse();


                UIManager.getRef(this.button_name_3).texture = Texture.from("plus_disable.png");
                UIManager.getRef(this.button_name_3).interactive = false;
                this.props.setWinAmount(true);
                this.onBetIncrease();
                // this.disableBetButtons()
                // SRM1-177 bug: setting the timer to 0 so that the button will refresh instantly
                // using the GAME_INFO.betLimit is used for spin duration and not the time between stake selection
                let timer1 = TIMER.TimerManager.createTimer(0);
                timer1.on('end', (e: any) => {
                    e.remove();
                    this.disableBetButtons()
                })
                timer1.start();
                return;
            case this.button_name_4:

                UIManager.getRef(this.button_name_4).texture = Texture.from("minus_disable.png");
                UIManager.getRef(this.button_name_4).interactive = false;
                this.props.setWinAmount(true);
                //this.props.getApplicationDecreaseBetResponse();
                this.onBetDecrease();
                //  this.disableBetButtons()
                // SRM1-177 bug: setting the timer to 0 so that the button will refresh instantly
                // using the GAME_INFO.betLimit is used for spin duration and not the time between stake selection
                let timer2 = TIMER.TimerManager.createTimer(0);
                timer2.on('end', (e: any) => {
                    e.remove();
                    this.disableBetButtons()
                })
                timer2.start();
                return;
            case this.button_name_5:
                this.soundOnButtonFunctionality();
                return;
            case this.button_name_6:

                // this.props.winShowerShow(true);
                // this.props.winShowerStart(true);
                return;
            case this.button_name_7:
                this.onAutoplayStop();
                return;
            case this.button_name_8:
                if (isMobile) {


                    this.props.setApplicationButtonpanelVisibility(false);
                }

                this.onAutoplayShow();
                return;
            case this.button_name_9:
                return;
            case this.button_name_10:
                this.props.setSelectedCoin(this.props.coinList.length - 1);
                this.props.setInsufficientFunds(false);
                this.props.setBuyFeatureStakeExceeds(false);
                this.updateStakeParameter()
                this.disableBetButtons()
                //this.props.getApplicationMaxBetResponse();
                return;
            case this.button_name_17:
                this.props.setSelectedCoin(0);
                this.props.setInsufficientFunds(false);
                this.props.setBuyFeatureStakeExceeds(false);
                this.updateStakeParameter()
                this.disableBetButtons()
                //this.props.getApplicationMaxBetResponse();
                return;
            case this.button_name_11:
                //this.settingPanelDisplayFunctionality();
                this.openGameSettigsPanel();
                return;
            case this.button_name_12:
                this.onAutoplayShow();
                return;
            case this.button_name_13:
                this.soundOffButtonFunctionality();

                return;
            case this.button_name_14:
                //(window as any).GAME_INFO.jurisdiction = "mt";

                if (this.props.oneClickRules) {



                    if (isMobile) {
                        this.props.setMenuButtonClicked(true);
                        UIManager.getRef("btn_menu").visible = false;
                        this.props.showSettingPanelContainerForMobile(true, 'guide');
                        this.props.setApplicationButtonpanelVisibility(false);
                        this.hideButtons();

                    } else {
                        this.props.setMenuButtonClicked(true);
                        UIManager.getRef("btn_menu").visible = false;
                        this.openMenuPanel();
                        this.props.showSettingGameRules(true);
                        this.hideOtherControls();
                    }


                } else {
                    if (isMobile) {
                        this.props.showSettingPanelContainerForMobile(true, 'guide');
                        this.props.setApplicationButtonpanelVisibility(false);
                        this.hideButtons();
                    } else {
                        this.props.setMenuButtonClicked(true);
                        e.target.visible = false;
                        this.openMenuPanel();
                    }
                }
                // this.spaceBarSpinstoreValue = this.props.spinWithSpaceBar;
                this.props.spaceBarSpin(false);

                return;
            case this.button_name_15:
                this.props.setMenuButtonClicked(false);
                e.target.visible = false;
                this.closeMenuPanel();

                return;
            case this.button_name_16:
                this.openBetPanel();
                this.disableBetButtons()
                return;
            case this.button_name_18:
                this.openGameRules();
                return;
            case this.button_name_19:
                this.openBetHistory();
                return;
            case this.button_name_20:
                this.onAutoplayStop();
                return;
            case this.button_name_21:
                this.onStopSpin();
                return;
            case this.button_name_22:
                this.homeButtonClicked();
                return;


            default:
                return 'No buttons';
        }
    }


    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.currentBetIndex !== this.props.currentBetIndex ||
            nextProps.allButtonEnable !== this.props.allButtonEnable ||
            nextProps.showWinCelebration !== this.props.showWinCelebration ||
            nextProps.showWinShower !== this.props.showWinShower ||
            nextProps.showSettingPanelUI !== this.props.showSettingPanelUI ||
            nextProps.autoplayCount !== this.props.autoplayCount ||
            nextProps.autoplayNextSpin !== this.props.autoplayNextSpin ||
            nextProps.inAutoplay !== this.props.inAutoplay ||
            nextProps.showAutoplayUI !== this.props.showAutoplayUI ||
            nextProps.feature !== this.props.feature ||
            nextProps.spinResponseReceived !== this.props.spinResponseReceived ||
            nextProps.layoutMode !== this.props.layoutMode ||
            nextProps.handMode !== this.props.handMode ||
            nextProps.hasCapped !== this.props.hasCapped ||

            nextProps.spinStart !== this.props.spinStart ||
            nextProps.blastStart !== this.props.blastStart ||
            nextProps.allSpinComplete !== this.props.allSpinComplete ||
            nextProps.isshowSettingGameRules !== this.props.isshowSettingGameRules ||
            nextProps.isshowBetHistory !== this.props.isshowBetHistory ||
            nextProps.isshowGameSettings !== this.props.isshowGameSettings ||
            //nextProps.soundIsPlaying !== this.props.soundIsPlaying ||
            nextProps.selectedCoin !== this.props.selectedCoin ||
            nextProps.featureJustFinished !== this.props.featureJustFinished ||
            nextProps.showSoundActiveScreen !== this.props.showSoundActiveScreen
            || nextProps.spinWithSpaceBar !== this.props.spinWithSpaceBar
            || nextProps.callFlowManager !== this.props.callFlowManager
            /*   || nextProps.stopButtonActive !== this.props.stopButtonActive */
            || nextProps.InTurboMode !== this.props.InTurboMode

        ) {
            /*   if (nextProps.stopButtonActive && nextProps.stopButtonActive !== this.props.stopButtonActive) {

                this.showSpinStopButton(nextProps);

                return false
              } */
            if (nextProps.InTurboMode !== this.props.InTurboMode) {
                return false
            }
            if (nextProps.InTurboMode !== this.props.InTurboMode) {
                return false
            }
            if (nextProps.spinWithSpaceBar !== this.props.spinWithSpaceBar) {

                !this.menuBtnClicked && (this.spaceBarSpinstoreValueChanged = true);

                return false
            }
            if (nextProps.callFlowManager !== this.props.callFlowManager) {
                if (nextProps.hasCapped) {
                    let max_popup = UIManager.getRef("max_popup");
                    max_popup && (max_popup.visible = true);
                    let popupbackgroundbtn = UIManager.getRef("popupbackgroundbtn");
                    if (popupbackgroundbtn) {
                        popupbackgroundbtn.on('click', this.clickPopupMaxBtn.bind(this));
                        popupbackgroundbtn.on('touchend', this.clickPopupMaxBtn.bind(this));
                    };
                    this.disableAllBtn();
                }

                return false
            }
            if (nextProps.hasCapped && nextProps.hasCapped !== this.props.hasCapped) {
                let max_popup = UIManager.getRef("max_popup");
                max_popup && (max_popup.visible = true);
                let popupbackgroundbtn = UIManager.getRef("popupbackgroundbtn");
                if (popupbackgroundbtn) {
                    popupbackgroundbtn.on('click', this.clickPopupMaxBtn.bind(this));
                    popupbackgroundbtn.on('touchend', this.clickPopupMaxBtn.bind(this));
                };
                this.disableAllBtn();
                return false
            }
            if (nextProps.isshowSettingGameRules !== this.props.isshowSettingGameRules ||
                nextProps.isshowBetHistory !== this.props.isshowBetHistory ||

                nextProps.isshowGameSettings !== this.props.isshowGameSettings) {

                return false;
            }



            if (nextProps.spinStart) {

                // this.textDisableVisibility();
                //    this.showSpinStopButton(nextProps);
                this.props.flowManagerCalled(false);
                this.resetUIValue();
            }

            if (nextProps.showSettingPanelUI !== this.props.showSettingPanelUI) {
                return false;
            }
            if (nextProps.showSoundActiveScreen !== this.props.showSoundActiveScreen) {
                let max_popup = UIManager.getRef("max_popup");
                max_popup && (max_popup.visible = false);
                if (nextProps.inFreeGame) {
                    this.disableAllBtn();
                }
                return false;
            }


            // if (nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {

            //     // let timer = TIMER.TimerManager.createTimer(2200);
            //     // timer.on('end', (e: any) => {
            //     //     e.remove();
            //     //     this.sendSpinAfterBlast();
            //     // })
            //     // timer.start();
            // }

            if (nextProps.allSpinComplete && nextProps.allSpinComplete !== this.props.allSpinComplete) {
                this.showWinAmount();
                this.setUIValue();
                this.props.setApplicationSpinButtonClicked(false);
                //RAJANU why u have changed this do not change generic thing at your end it always give problem try to solve on ly in client side

                // this.enableAllBtn([])

            }

            if (nextProps.selectedCoin !== this.props.selectedCoin) {
                this.coinValueObject && (this.coinValueObject.text = nextProps.coinList[nextProps.selectedCoin]);
                return false;
            }
            if (nextProps.layoutMode !== this.props.layoutMode
                || nextProps.handMode !== this.props.handMode

            ) {
                this.layoutChange(nextProps.layoutMode)

                let timer = TIMER.TimerManager.createTimer(1);
                timer.on('end', (e: any) => {
                    e.remove();



                    if (nextProps.hasCapped) {
                        let max_popup = UIManager.getRef("max_popup");
                        max_popup && (max_popup.visible = true);
                        let popupbackgroundbtn = UIManager.getRef("popupbackgroundbtn");
                        if (popupbackgroundbtn) {
                            popupbackgroundbtn.on('click', this.clickPopupMaxBtn.bind(this));
                            popupbackgroundbtn.on('touchend', this.clickPopupMaxBtn.bind(this));
                        };
                        this.disableAllBtn();
                    } else {
                        let max_popup = UIManager.getRef("max_popup");
                        max_popup && (max_popup.visible = false);
                    }


                    this.handleStateOnSwitchControl(nextProps.handMode)
                    this.handleSwitchOnLandscape();
                    this.handleSoundButtonVisibility();

                })
                timer.start();

                return false;

            }

            if (nextProps.spinResponseReceived && nextProps.spinResponseReceived !== this.props.spinResponseReceived && !nextProps.blastStart) {

                if (isMobile) {

                    var d = new Date();
                    var n = d.getTime();
                    this.btnDisableTime = n;
                    if (Number(configGame["SPIN_TYPE"]) === 0) {
                        const {
                            startSpin
                        } = nextProps;
                        startSpin();
                    } else if (Number(configGame["SPIN_TYPE"]) === 2) {
                        const {
                            startRGSpin
                        } = nextProps;
                        startRGSpin();
                    } else {
                        const {
                            startGridSpin
                        } = nextProps;
                        startGridSpin();
                    }
                }
            }
            if (nextProps.currentBetIndex !== this.props.currentBetIndex && !nextProps.inAutoplay && nextProps.layoutMode === this.props.layoutMode || nextProps.allButtonEnable && !nextProps.inAutoplay &&
                nextProps.layoutMode === this.props.layoutMode) {

                //RAJANU why you have commented this this is going to enable button panel after reel stop do not change core functionality 
                if (nextProps.feature.length > 0 || this.props.autoplayCount > 0) {
                    this.disableAllBtn();
                } else {
                    var d = new Date();
                    var n = d.getTime();
                    this.btnEnableTime = n;
                    this.btnEnableGap = this.btnEnableTime - this.btnDisableTime;
                    if (this.btnEnableGap >= nextProps.betLimit) {

                        this.enableAllBtn(["btn_autoplay_stop" + this.ui_mode]);
                    } else {
                        let timer = TIMER.TimerManager.createTimer(nextProps.betLimit - this.btnEnableGap);
                        timer.on('end', (e: any) => {
                            e.remove();
                            this.btnDisableTime = 0;
                            this.btnEnableTime = 0;
                            this.btnEnableGap = 0;
                            this.enableAllBtn(["btn_autoplay_stop" + this.ui_mode]);
                        })
                        timer.start();
                    }
                }

                if (nextProps.selectedCoin === nextProps.betList.length - 1) {


                    if (!nextProps.inFreeGame) {
                        this.enableAllBtn(["btn_bet_increase", "btn_autoplay_stop" + this.ui_mode]);
                    }
                }
                if (nextProps.selectedCoin === -1 && !(this.props.autoplayCount > 0)) {

                    this.enableAllBtn(["btn_bet_decrease", "btn_autoplay_stop" + this.ui_mode]);
                }

                //return false;
            }
            if (!nextProps.allButtonEnable && nextProps.allButtonEnable !== this.props.allButtonEnable) {
                this.textVisibility(nextProps);
                if (nextProps.inAutoplay) {
                    this.disableAllBtn(["btn_autoplay_stop" + this.ui_mode]);
                } else {
                    this.disableAllBtn();
                }
            }
            if (nextProps.inAutoplay && nextProps.inAutoplay !== this.props.inAutoplay) {

                this.textVisibility(nextProps);
                this.autoplayIsTrue();

                return false;
            } else if (!nextProps.inAutoplay && nextProps.inAutoplay !== this.props.inAutoplay) {
                // this.textEnableVisibility();
                this.autoplayIsFalse();
                return false;
            }


            if (nextProps.autoplayCount > 0 && nextProps.inAutoplay && nextProps.autoplayNextSpin && nextProps.autoplayNextSpin !== this.props.autoplayNextSpin
                || nextProps.autoplayCount > 0 && nextProps.featureJustFinished) {

                this.autoplayIsTrue();
                this.disableAllBtn(["btn_autoplay_stop" + this.ui_mode]);
                if (!nextProps.inFreeGame) {

                    if (nextProps.featureJustReTriggered == false && !nextProps.showWinCelebration && !nextProps.showWinShower) {
                        if (nextProps.allSpinComplete && !nextProps.winPresentationStart) {

                            this.spinCallingWhileAutoplay(nextProps);
                        }

                    }

                }
                //this.spinCallingWhileAutoplay(nextProps);
            }



        }
        if (this.props.isshowSettingGameRules || this.props.isshowGameSettings || this.props.isshowBetHistory) {
            if (nextProps.soundIsPlaying !== this.props.soundIsPlaying) {

                this.soundButtonVisibility(nextProps.soundIsPlaying)
                return false;
            }
        }


        if (nextProps.menuBtnClicked !== this.props.menuBtnClicked) {

            if (nextProps.menuBtnClicked) {

                this.openMenuFromWrapper();
            } else {
                this.closeMenuFromWrapper();
            }
            return false;
        }

        return true;


    }

    handleSoundButtonVisibility() {
        if (isMobile) {
            UIManager.getRef("btn_sound").visible = this.props.soundIsPlaying;
            UIManager.getRef("btn_soundOff").visible = !this.props.soundIsPlaying;
        }
    }

    handleSwitchOnLandscape() {
        let btn_spinStoke = UIManager.getRef("btn_spinStoke");
        if (btn_spinStoke) {
            if (this.props.handMode === "left") {
                if (window.innerHeight < window.innerWidth) {
                    btn_spinStoke.scale.x = -1;

                } else {
                    btn_spinStoke.scale.x = 1;
                }
            } else {
                btn_spinStoke.scale.x = 1;
            }
        }

    }

    soundButtonVisibility(isSoundPlaying: boolean) {

        UIManager.getRef(this.button_name_5) && (UIManager.getRef(this.button_name_5).visible = isSoundPlaying);
        UIManager.getRef(this.button_name_13) && (UIManager.getRef(this.button_name_13).visible = !isSoundPlaying);

        this.handleButtonsOnCloseMenu();
    }


    // this method will call spin method as much time as autoSpin Count left
    spinCallingWhileAutoplay(nextProps: any) {
        let timer = TIMER.TimerManager.createTimer(1000);
        timer.on('end', (e: any) => {
            e.remove();

            this.onSpin();
        })
        timer.start();
        let remainingAutoplay = nextProps.autoplayCount - 1;
        if (remainingAutoplay <= 0) {
            this.props.stopAutoplay();
            this.displayUI.map((data: any) => {
                if (data.name === "btn_autoplay") {
                    data.visible = true
                }
                if (data.name === "btn_autoplay_stop" + this.ui_mode) {
                    data.visible = false
                }
            })

            // if (isMobile) {
            //     this.displayUI.map((data: any) => {
            //         if (data.name === "btn_autoplay_stop" + this.ui_mode) {
            //             data.visible = false
            //         }
            //     })

            // }
        }

        this.props.setApplicationAutoplayCount(remainingAutoplay);
    }

    //this method will call when autoplay has false,this will enable all buttons and un hide autoplay button
    autoplayIsFalse() {
        this.displayUI.map((data: any) => {
            if (data.name === "btn_autoplay") {
                data.visible = true
            }
            if (data.name === "btn_autoplay_stop" + this.ui_mode) {
                data.visible = false
            }
        })

        if (isMobile) {
            this.displayUI.map((data: any) => {
                if (data.name === "btn_autoplay_stop" + this.ui_mode) {
                    data.visible = false
                }
            })

        }
    }

    //this method will call when autoplay has started,this will disable all buttons and un hide autoplay stop button
    autoplayIsTrue() {
        this.disableAllBtn(["btn_autoplay_stop" + this.ui_mode]);
        this.displayUI.map((data: any) => {
            if (data.name === "btn_autoplay") {
                data.visible = false
            }
            if (data.name === "btn_autoplay_stop" + this.ui_mode) {
                data.visible = true
            }
        })

        if (isMobile) {

            this.displayUI.map((data: any) => {
                if (data.name === "btn_autoplay_stop" + this.ui_mode) {
                    data.visible = true
                }
            })
        }

    }

    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {

        this.displayUI.map((data: any) => {
            if (data.layout === true && this.alwaysHideButton.indexOf(data.name) == -1) {
                this.props.setApplicationLayoutObject(data.name)
            }
        }
        )
        this.strokeButtonRotate();
        // let max_popup = UIManager.getRef("max_popup");
        // max_popup && (max_popup.visible = false);
    }

    showWinAmount() {
        // if (!isMobile) {
        //      if (this.props.winAmount !== 0) {
        //      UIManager.getRef("text_win_value1").visible=true;
        //      UIManager.getRef("text_win_value1") && (UIManager.setText("text_win_value1", this.props.winAmount));
        //     // this.balanceValueObject && (this.balanceValueObject.text = this.props.balance + this.props.winAmount);
        //
        //  } else {
        //      UIManager.getRef("text_win_value1").visible=false;
        //
        //  }
        //  }
    }

    textVisibility(nextProps: any) {
        this.displayUI.map((data: any) => {
            if (data.name == "text_maxBet_label1" || data.name == "text_maxBet_label2" || data.name == "text_maxBet_label2") {
                data.visible = false;
            } else if (data.name == "text_maxBet_label1_grey" || data.name == "text_maxBet_label2_grey" || data.name == "text_maxBet_label2_grey") {
                data.visible = true;
            }

            if (nextProps.inAutoplay) {
                if (data.name == "text_AUTOPLAY_label1_grey" || data.name == "text_AUTOPLAY_label2_grey") {
                    data.visible = false;
                }
                if (data.name == "text_AUTOPLAY_label1" || data.name == "text_AUTOPLAY_label2") {
                    data.visible = true;
                }
            }
            else {
                if (data.name == "text_AUTOPLAY_label1_grey" || data.name == "text_AUTOPLAY_label2_grey") {
                    data.visible = true;
                }
                if (data.name == "text_AUTOPLAY_label1" || data.name == "text_AUTOPLAY_label2") {
                    data.visible = false;
                }
            }

        })
    }


    textEnableVisibility() {
        this.displayUI.map((data: any) => {
            if (data.name == "text_maxBet_label1" || data.name == "text_maxBet_label2" || data.name == "text_AUTOPLAY_label1" || data.name == "text_AUTOPLAY_label2") {
                data.visible = true;
            }
            if (data.name == "text_maxBet_label1_grey" || data.name == "text_maxBet_label2_grey" || data.name == "text_AUTOPLAY_label1_grey" || data.name == "text_AUTOPLAY_label2_grey") {
                data.visible = false;
            }
        })
    }

    handleButtonsOnCloseMenu() {
        if (!isMobile) {
            let btn_spin: any = UIManager.getRef("btn_spin");
            let btn_sound: any = UIManager.getRef("btn_sound");
            let btn_menu: any = UIManager.getRef("btn_menu");
            if (this.props.handMode === "left") {
                btn_menu && (btn_menu.x = 1800)
                btn_menu && (btn_menu.y = 935)
            } else {
                btn_menu && (btn_menu.x = 26)
                btn_menu && (btn_menu.y = 939)
            }
            if (this.props.handMode === "left") {
                btn_spin && (btn_spin.x = 10)
                btn_spin && (btn_spin.y = 900)
            } else {
                btn_spin && (btn_spin.x = 1770)
                btn_spin && (btn_spin.y = 900)
            }
            if (this.props.handMode === "left") {
                btn_sound && (btn_sound.x = 1715)
                btn_sound && (btn_sound.y = 964)
            } else {
                btn_sound && (btn_sound.x = 138)
                btn_sound && (btn_sound.y = 964)
            }

        }

    }
    showSpinStopButton(props: any) {
        if (props.stopButtonActive && props.spinStopButton && !props.allButtonEnable && !props.showAutoplayUI && !props.inAutoplay && !props.inFreeGame && !props.InTurboMode) {
            UIManager.getRef("btn_spinStop").visible = true;
        }
        else {
            UIManager.getRef("btn_spinStop").visible = false;
        }
    }


    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        // this.showSpinStopButton(this.props);
        let gameBtnExit: any = UIManager.getRef("btn_game_exit");
        gameBtnExit && (gameBtnExit.visible = false);
        this.initializeObjectInVariable();
        this.layoutChange(this.props.layoutMode);
        let timer1 = TIMER.TimerManager.createTimer(10);
        timer1.on('end', () => {

            if (this.props.autoplayCount >= 0) {
                if (this.props.autoplayCount === 0) {
                    this.autoplayCounterObject && (this.autoplayCounterObject.visible = false);
                } else {
                    this.autoplayCounterObject && (this.autoplayCounterObject.visible = true);

                }
                this.setTextValue("Text_COUNT_AP" + this.ui_mode, this.props.autoplayCount);

            }

            if (!isMobile) {

                this.soundButtonVisibility(this.props.soundIsPlaying)
            }
            if (this.props.isshowSettingGameRules || this.props.isshowBetHistory || this.props.isshowGameSettings) {
                this.hideOtherControls();
            }

            if (this.props.spinStart || !this.props.allButtonEnable) {
                let menuBtnClose: any = UIManager.getRef("btn_menu_close");
                menuBtnClose.visible = false;
                // this.showSpinStopButton(this.props);
            }
            let timer = TIMER.TimerManager.createTimer(0.1);
            timer.on('end', (e: any) => {
                e.remove();

                this.soundButtonVisibility(this.props.soundIsPlaying)
                this.switchBetPanelButtons(this.props.handMode);
                if (this.props.autoplayCount > 0) {
                    UIManager.getRef("btn_autoplay_stop" + this.ui_mode) && (UIManager.getRef("btn_autoplay_stop" + this.ui_mode).visible = true);
                }

                if (isMobile) {
                    this.handleSwitchOnLandscape();
                }
            })
            timer.start();

            this.strokeButtonRotate();
        });
        timer1.start();

        this.autoplayDisabledState();
        this.setBetGraphicForPortrait();
    }
    setBetGraphicForPortrait() {
        let hitAreaGraphic = UIManager.getRef("winCelebration_Graphic");
        if (isMobile && window.innerWidth < window.innerHeight) {
            hitAreaGraphic.height = 1500;
        }
        else {
            hitAreaGraphic.height = 800;
        }

    }
    autoplayDisabledState() {
        let btn_autoplay: any = UIManager.getRef("btn_autoplay");
        if (btn_autoplay && this.props.disableAutoplay) {

            if (isMobile) {
                btn_autoplay.interactive = false;
            }
            else {

                btn_autoplay.texture = Texture.from("autoplay_disable.png");
                btn_autoplay.interactive = false;
            }



        }
    }
    strokeButtonRotate() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("btn_spinStoke") && (UIManager.getRef("btn_spinStoke").rotation = 1.56);
        }
        else if (isMobile && window.innerWidth > window.innerHeight) {
            UIManager.getRef("btn_spinStoke") && (UIManager.getRef("btn_spinStoke").rotation = 0);
        }
    }
    handleStateOnSwitchControl(nextProps: any) {
        if (this.props.isshowSettingGameRules || this.props.isshowBetHistory || this.props.isshowGameSettings) {
            this.hideOtherControls();
            let menuBtn: any = UIManager.getRef("btn_menu");
            menuBtn.visible = false;
        }

        if (this.props.spinStart || !this.props.allButtonEnable) {
            let menuBtnClose: any = UIManager.getRef("btn_menu_close");
            menuBtnClose.visible = false;
            //  this.showSpinStopButton(this.props);
        }

        this.showOpenSettingButtons();
        this.switchBetPanelButtons(nextProps);
    }

    switchBetPanelButtons(handMode: any) {
        let btn_bet_decrease = UIManager.getRef("btn_bet_decrease");
        let btn_bet_increase = UIManager.getRef("btn_bet_increase");
        let btn_minbet = UIManager.getRef("btn_minbet");
        let btn_maxbet = UIManager.getRef("btn_maxbet");

        if (handMode === 'right') {
            btn_bet_decrease && btn_bet_decrease.position.set(150, 27)
            btn_bet_increase && btn_bet_increase.position.set(355, 27)
            btn_minbet && btn_minbet.position.set(35, 17)
            btn_maxbet && btn_maxbet.position.set(454, 17)
        } else {
            btn_bet_decrease && btn_bet_decrease.position.set(355, 27)
            btn_bet_increase && btn_bet_increase.position.set(150, 27)
            btn_minbet && btn_minbet.position.set(454, 17)
            btn_maxbet && btn_maxbet.position.set(35, 17)
        }

    }

    showOpenSettingButtons() {
        if (!isMobile) {
            let menuBtnClose: any = UIManager.getRef("btn_menu_close");
            menuBtnClose && (menuBtnClose.visible = true);
            let historyBtn: any = UIManager.getRef("historyBtnContainer");
            historyBtn && (historyBtn.visible = true);
            let settingBtn: any = UIManager.getRef("settingBtnContainer");
            settingBtn.visible = true;
            let gameRuleBtn: any = UIManager.getRef("gameRulesBtnContainer");
            gameRuleBtn.visible = true;
            this.addTweenToButtons(historyBtn, 855, 0);
            this.addTweenToButtons(settingBtn, 760, 0);
            this.addTweenToButtons(gameRuleBtn, 670, 0);
        }
    }

    //this method will initialize object to variables
    initializeObjectInVariable() {
        this.betValueObject = "text_bet_value1";
        this.coinValueObject = UIManager.getRef("text_coinValue_value");
        // this.balanceValueObject = UIManager.getRef("text_balance_value");
        this.autoplayCounterObject = UIManager.getRef("Text_COUNT_AP" + this.ui_mode);
        this.winValueObject = "text_win_value1";
        this.autoplayStopButtonObject = UIManager.getRef("btn_autoplay_stop" + this.ui_mode);
    }

    componentDidMount() {


        if (this.props.allButtonEnable) {
            this.textEnableVisibility();
        }
        this.layoutChange(this.props.layoutMode);
        this.displayUI.map((data: any) => {
            let obj = this.state[data.name];

            if (obj) {
                obj.enable = data.interactive;
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        [data.name]: obj
                    }
                })
            }
        })
        if (this.props.selectedCoin === 0) {


            this.enableAllBtn(["btn_bet_decrease", "btn_autoplay_stop" + this.ui_mode]);
        }
        // setTimeout(() => {
        //     let max_popup = UIManager.getRef("max_popup");
        //     max_popup && (max_popup.visible = true);
        //     let popupbackgroundbtn = UIManager.getRef("popupbackgroundbtn");
        //     if (popupbackgroundbtn) {
        //         popupbackgroundbtn.on('click', this.clickPopupMaxBtn);
        //         popupbackgroundbtn.on('touchend', this.clickPopupMaxBtn);
        //     };
        //     this.disableAllBtn();
        // }, 5000);
        let max_popup = UIManager.getRef("max_popup");
        max_popup && (max_popup.visible = false);
        //   this.showSpinStopButton(this.props);

    }

    clickPopupMaxBtn() {

        let max_popup = UIManager.getRef("max_popup");
        max_popup && (max_popup.visible = false);
        this.props.setHasCapped(false);
        this.props.flowManagerCalled(true);
    }

    //this method will disable the buttons which is passed as a argument, if nothing is passed then all buttons will be disable
    disableAllBtn(exceptList: Array<string> = []) {
        //  this.showSpinStopButton();
        if (this.props.inAutoplay) {
            // this.textVisibility();
        }

        if (this.props.inFreeGame) {
            exceptList = []
        }

        this.props.setAllButtonDisable(exceptList);
        this.displayUI.map((data: any) => {
            let obj = this.state[data.name];

            if (obj) {
                if (exceptList.length > 0 && exceptList.indexOf(data.name) > -1 || (this.props.alwaysEnableButtonNameList.indexOf(data.name) > -1)) {
                    obj.enable = true;
                } else {
                    obj.enable = false;
                }

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        [data.name]: obj
                    }
                })
            }


        })
    }

    //this method will enable the buttons which is passed as a argument, if nothing is passed then all buttons will be enable
    enableAllBtn(exceptList: Array<string> = []) {
        if (!this.props.inAutoplay) {
            this.textEnableVisibility();
        }
        if (this.props.inFreeGame) {
            exceptList = []
        }
        this.props.setAllButtonEnable(exceptList);
        this.displayUI.map((data: any) => {
            let obj = this.state[data.name];

            if (obj) {
                if (exceptList.length > 0 && exceptList.indexOf(data.name) > -1 && (this.props.alwaysEnableButtonNameList.indexOf(data.name) === -1)) {
                    obj.enable = false;

                } else {
                    obj.enable = true;
                }

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        [data.name]: obj
                    }
                })
            }


        })
    }


    //this method will set values of text
    setUIValue() {
        //this.balanceValueObject && (this.balanceValueObject.text = this.props.balance);
        //  UIManager.getRef(this.betValueObject) && (UIManager.setText(this.betValueObject, this.props.betList[this.props.currentBetIndex]));

    }

    //this method will reset values of text
    resetUIValue() {
        // this.balanceValueObject && (this.balanceValueObject.text = this.props.balance );
        // UIManager.getRef(this.betValueObject) && (UIManager.setText(this.betValueObject, this.props.betList[this.props.currentBetIndex]));

    }

    //this method will initially bind values to text
    bindUI() {
        // this.balanceValueObject && (this.balanceValueObject.text = this.props.balance);
        // UIManager.getRef(this.betValueObject) && (UIManager.setText(this.betValueObject, this.props.betList[this.props.currentBetIndex]));
        this.setTextValue("text_coinValue_value", this.props.coinList[this.props.selectedCoin] / 2000);
    }

    //this method will set the text
    setTextValue(name: string, property: any) {
        UIManager.getRef(name) && (UIManager.setText(name, property));
    }

    mouseOver() {

        //alert("mouseOver")
    }
    mouseOut() {

    }

    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    handleEventtest = (e: any) => {

        return false;
    }
    render() {

        return (
            <UIManager id={"buttonPanelGenericUIContainer"} type={"Container"}
                ref={i => this.buttonPanelGenericUIContainer = i} app={this.app} configGame={configGame}>

                {
                    this.displayUI.map((data: any) => (
                        //data.ClickHandler=this.handleEventtest.bind(this)
                        // if( this.alwaysHideButton){

                        //                 }

                        (this.alwaysHideButton.indexOf(data.name) > -1) || (this.props.alwaysEnableButtonNameList.indexOf(data.name) > -1 || this.props.exceptBtnList.indexOf(data.name) > -1) && (

                            (this.props.alwaysEnableButtonNameList.indexOf(data.name) > -1) &&

                            <UIManager key={`UIManager-${Math.random()}`} type={data.type}
                                ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut} langObj={this.props.langObj}
                                disabled={!this.state[data.name].enable} id={data.id} {...data} app={this.app} />
                            ||
                            (this.props.allButtonEnable && this.props.exceptBtnList.indexOf(data.name) > -1) &&
                            <UIManager key={`UIManager-${Math.random()}`} type={data.type} app={this.app}
                                ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut} langObj={this.props.langObj}
                                disabled={!this.state[data.name].enable} id={data.id} {...data} />
                            ||
                            <UIManager key={`UIManager-${Math.random()}`} type={data.type} app={this.app}
                                ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut} langObj={this.props.langObj}
                                disabled={!this.state[data.name].enable} id={data.id} {...data} />
                        )
                        ||
                        (

                            <UIManager key={`UIManager-${Math.random()}`} type={data.type} app={this.app}
                                ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut} langObj={this.props.langObj}
                                disabled={this.state[data.name] && !this.state[data.name].enable}
                                id={data.id} {...data} />)


                    )
                    )

                }
            </UIManager>
        )

    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'flowManagerState' | 'keyboardListenerState' | 'winShowerState' | 'wrapperState' | 'soundActiveScreenState' | 'reelgridState' | 'freegameState' | 'winCelebrationState' | 'winpresentationState' | 'betPanelState' | 'reelsState' | 'buttonPanelState' | 'soundState' | 'basegameState' | 'gridsState' | 'autoplayState' | 'applicationState' | 'desktopSettingPanelState' | 'playerMessageState' | 'asyncServerAction' | 'behaviourState'>) =>
    ({
        spinResponseReceived: Number(configGame["SPIN_TYPE"]) === 1 && state.gridsState.spinResponseReceived || Number(configGame["SPIN_TYPE"]) === 2 && state.reelgridState.spinResponseReceived || state.reelsState.spinResponseReceived,

        spinStart: Number(configGame["SPIN_TYPE"]) === 1 && state.gridsState.spinStart || Number(configGame["SPIN_TYPE"]) === 2 && state.reelgridState.spinStart || state.reelsState.spinStart,
        showAutoplayUI: state.autoplayState.showAutoplay,
        allButtonEnable: state.buttonPanelState.allButtonEnable,
/*         stopButtonActive: state.buttonPanelState.stopButtonActive,
 */        exceptBtnList: state.buttonPanelState.exceptBtnList,
        currentBetIndex: state.basegameState.currentBetIndex,
        betList: state.basegameState.betList,
        autoplayCount: state.basegameState.autoplayCount,
        autoplayNextSpin: state.basegameState.autoplayNextSpin,
        basegamestate: state.basegameState.basegamestate,
        inAutoplay: state.basegameState.inAutoplay,
        feature: state.basegameState.feature,
        handMode: state.applicationState.handMode,
        layoutMode: state.applicationState.layoutMode,
        showSettingPanelUI: state.desktopSettingPanelState.showSettingPanel,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,
        allSpinComplete: state.reelgridState.allSpinComplete,
        winAmount: state.basegameState.winAmount,
        balance: state.basegameState.balance,
        soundIsPlaying: state.soundState.soundIsPlaying,
        menuBtnClicked: state.behaviourState.menuBtnClicked,
        isshowSettingGameRules: state.behaviourState.showSettingGameRules,
        isshowBetHistory: state.behaviourState.showBetHistory,
        hasCapped: state.behaviourState.hasCapped,
        isshowGameSettings: state.behaviourState.showGameSettings,
        inFreeGame: state.freegameState.inFreeGame,
        winPresentationStart: state.winpresentationState.winPresentationStart,
        featureJustFinished: state.freegameState.featureJustFinished,
        blastStart: state.reelgridState.blastStart,
        showWinCelebration: state.winCelebrationState.showWinCelebration,
        featureJustReTriggered: state.freegameState.featureJustReTriggered,
        showSoundActiveScreen: state.soundActiveScreenState.showSoundActiveScreen,
        betLimit: state.wrapperState.betLimit,
        oneClickRules: state.wrapperState.oneClickRules,
        showGameRules: state.behaviourState.showSettingGameRules,
        disableAutoplay: state.wrapperState.disableAutoplay,
        showWinShower: state.winShowerState.showWinShower,
        spinWithSpaceBar: state.keyboardListenerState.spinWithSpaceBar,
        callFlowManager: state.flowManagerState.callFlowManager,
        spinStopButton: state.wrapperState.spinStopButton,
        InTurboMode: state.gridsState.InTurboMode,
        homeButton: state.wrapperState.homeButton,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        resetReelState: (): any => dispatch(Number(configGame["SPIN_TYPE"]) === 0 && reelsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 1 && gridsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 2 && reelsGridActions.resetReelState()),
        forceStopSpin: (): any => dispatch(gridsActions.forceStopSpin()),
        startSpin: (): any => dispatch(reelsActions.startSpin()),
        startRGSpin: (): any => dispatch(reelGridActions.startSpin()),
        startGridSpin: (): any => dispatch(gridsActions.startSpin()),
        startAutoplay: (): any => dispatch(baseGameActions.startAutoplay()),
        stopAutoplay: (): any => dispatch(baseGameActions.stopAutoplay()),
        setApplicationAutoplayCount: (autoplaycount: number): any => dispatch(baseGameActions.setApplicationAutoplayCount(autoplaycount)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        setApplicationSpinButtonClicked: (isClicked: boolean): any => dispatch(buttonActions.setApplicationSpinButtonClicked(isClicked)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        getApplicationHistoryResponse: (): any => dispatch(asyncActions.getApplicationHistoryResponse()),
        showPaytable: (): any => dispatch(paytableActions.showPaytable()),
        showAutoplay: (): any => dispatch(autoplayActions.showAutoplayUI()),
        showMenuUI: (): any => dispatch(menuActions.showMenuUI()),
        /*    setStopActive: (stopActive: boolean): any => dispatch(buttonActions.setStopActive(stopActive)), */
        setApplicationButtonClicked: (clicked: boolean): any => dispatch(buttonActions.setApplicationButtonClicked(clicked)),
        limitOfLoss: (lossLimit: boolean): any => dispatch(autoplayActions.limitOfLoss(lossLimit)),
        setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        showDesktopSettingPanelUI: (showSettingPanel: boolean): any => dispatch(desktopSettingPanelActions.showDesktopSettingPanelUI(showSettingPanel)),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        setSelectedCoin: (selectedCoin: number): any => dispatch(betPanelAction.setSelectedCoin(selectedCoin)),
        playingSound: (soundIsPlaying: any): any => dispatch(soundActions.playingSound(soundIsPlaying)),
        stopAllBGMSound: (stopBgSound: any): any => dispatch(soundActions.stopAllBGMSound(stopBgSound)),
        stopAllSFXSound: (stopSfxSound: any): any => dispatch(soundActions.stopAllSFXSound(stopSfxSound)),
        // increaseBet: (betIncrease: any): any => dispatch(gameLevelResponseActions.increaseBet(betIncrease)),
        getApplicationIncreaseBetResponse: (): any => dispatch(gameLevelResponseActions.getApplicationIncreaseBetResponse()),
        getApplicationDecreaseBetResponse: (): any => dispatch(gameLevelResponseActions.getApplicationDecreaseBetResponse()),
        getApplicationMaxBetResponse: (): any => dispatch(gameLevelResponseActions.getApplicationMaxBetResponse()),
        setWinAmount: (winAmountEmpty: any): any => dispatch(behaviourAction.setWinAmount(winAmountEmpty)),
        showSettingGameRules: (showGameRules: any): any => dispatch(behaviourAction.showSettingGameRules(showGameRules)),
        setShowGameSettings: (showGameSettings: any): any => dispatch(behaviourAction.setShowGameSettings(showGameSettings)),
        setMenuButtonClicked: (menuBtnClicked: any): any => dispatch(behaviourAction.setMenuButtonClicked(menuBtnClicked)),
        showBetHistory: (showHistory: any): any => dispatch(behaviourAction.showBetHistory(showHistory)),
        setInsufficientFunds: (insuffFunds: any): any => dispatch(behaviourAction.setInsufficientFunds(insuffFunds)),
        setBuyFeatureStakeExceeds: (betExceeds: any): any => dispatch(behaviourAction.setBuyFeatureStakeExceeds(betExceeds)),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        setShowLockedReel: (): any => dispatch(lockedReelActions.setShowLockedReel()),
        setApplicationPause: (pause: boolean): any => dispatch(aplicationActions.setApplicationPause(pause)),
        spaceBarSpin: (spinWithSpaceBar: boolean): any => dispatch(keyboardListenerActions.spaceBarSpin(spinWithSpaceBar)),
        setHasCapped: (hasCappedAction: any): any => dispatch(behaviourAction.setHasCapped(hasCappedAction)),

        setApplicationButtonpanelVisibility: (visible: boolean): any => dispatch(aplicationActions.setApplicationButtonpanelVisibility(visible)),
        soundLoadStartFunction: (soundLoadStart: boolean): any => dispatch(soundActions.soundLoadStartFunction(soundLoadStart)),
        showSettingPanelContainerForMobile: (showSettingPanelForMobile: boolean, openScreen: any): any => dispatch(mainSettingPanelActions.showSettingPanelContainerForMobile(showSettingPanelForMobile, openScreen)),
        //setReelTurboMode: (IsTurboMode: any): any => dispatch(reelsActions.setTurboMode(reelsActions.setTurboMode(IsTurboMode))),
    }))(withButtonPanelConfiguration(ButtonPanelGenericUI)));

